import { reset } from 'redux-form';

import { storeKeys, removeKeys } from '../utils/helpers/storageManager';

import AuthService from '../utils/services/AuthService';
import UserService from '../utils/services/UserService';
import { showSpinner, viewSpinner, hideSpinner } from './general';
import { getProfileFromToken } from './userActionCreators';
import {
  wrongUsernameOrPasswordNotification,
  successNotification,
  errorGeneralNotification,
  customNotification,
} from './notifications';

import {
  AUTH_START,
  AUTH_FAIL,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
} from './authenticationTypes';

export const logout = () => {
  removeKeys(
    'token',
    'expirationDate',
    'userId',
    'email',
    'name',
    'partner',
    'profileId',
    'permissions',
    'referenceCode',
    'user_type',
    'currency',
    'country'
  );
  return {
    type: AUTH_LOGOUT,
  };
};

export const checkAuthTimeout = expirationTime => dispatch => {
  setTimeout(() => {
    dispatch(logout());
  }, expirationTime * 1000);
};

export const authStart = () => ({
  type: AUTH_START,
});

export const authSuccess = token => {
  storeKeys({
    token,
    user_type: 'Administrador',
  });

  return {
    type: AUTH_SUCCESS,
    token,
  };
};

export const authFail = error => ({
  type: AUTH_FAIL,
  error,
});

export const auth = (email, password) => dispatch => {
  dispatch(authStart());
  dispatch(showSpinner(true));

  window.localStorage.setItem('country', 'do');

  AuthService.getIp()(async res => {
    const data = res.data ? res.data.country.toLowerCase() : 'do';
    await window.localStorage.setItem('country', data);
  });

  AuthService.signIn(email, password)(
    res => {
      const { token } = res.data.data;

      if (!token) {
        dispatch(authFail());
        return;
      }

      const expiresIn = 36000;
      const expirationDate = new Date(new Date().getTime() + expiresIn * 1000);

      localStorage.setItem('expirationDate', expirationDate);

      dispatch(getProfileFromToken(token));
      dispatch(checkAuthTimeout(expiresIn));
    },
    undefined,
    () => {
      dispatch(showSpinner(false));

      dispatch(wrongUsernameOrPasswordNotification());
    }
  );
};

export const authCheckState = () => dispatch => {
  const token = localStorage.getItem('token');

  if (!token) {
    dispatch(logout());
  } else {
    const expirationDate = new Date(localStorage.getItem('expirationDate'));

    if (expirationDate <= new Date()) {
      dispatch(logout());
    } else {
      const remainingTime =
        (expirationDate.getTime() - new Date().getTime()) / 1000;

      dispatch(checkAuthTimeout(remainingTime));
    }
  }
};

export const signUp = values => dispatch => {
  dispatch(viewSpinner());

  const {
    departmentId,
    email,
    groupId,
    isSupervisor,
    name,
    password,
    positionId,
  } = values;

  AuthService.signUp(
    departmentId,
    email,
    groupId,
    isSupervisor,
    name,
    password,
    positionId
  )(
    res => {
      dispatch(viewSpinner());

      const { userId } = res.data.data;
      const {
        name,
        referenceCode,
        zone,
        entryDate,
        departureDate,
        salary,
        monthlyGoal,
        monthlyBonus,
        status,
      } = values;

      UserService.createProfile(
        'iban',
        departureDate,
        entryDate,
        monthlyBonus,
        monthlyGoal,
        name,
        referenceCode,
        salary,
        userId,
        status,
        zone
      )(
        () => {
          dispatch(successNotification('Usuario creado satisfactoriamente!'));
          dispatch(reset('create-account-form'));
          dispatch(hideSpinner());
        },
        () => {
          dispatch(hideSpinner());
        },
        () => {
          dispatch(hideSpinner());
          dispatch(
            customNotification(
              'Error',
              'Se produjo un error y no se pudo completar su solicitud. Inténtalo de nuevo.',
              'error'
            )
          );
        }
      );
    },
    () => {
      dispatch(successNotification('Usuario creado satisfactoriamente!'));
      dispatch(reset('create-account-form'));
      dispatch(hideSpinner());
    },
    () => {
      dispatch(hideSpinner());
    },
    () => {
      dispatch(hideSpinner());
      dispatch(
        customNotification(
          'Error',
          'Se produjo un error y no se pudo completar su solicitud. Inténtalo de nuevo.',
          'error'
        )
      );
    }
  );
};

export const sendRegistrationTokenTo = (name, email, appName) => dispatch => {
  dispatch(viewSpinner());

  AuthService.sendRegistrationToken(name, email, appName)(
    () => {
      dispatch(successNotification('Solicitud enviada con éxito!'));
    },
    () => {
      dispatch(hideSpinner());
    },
    () => {
      dispatch(errorGeneralNotification());
    }
  );
};



// WEBPACK FOOTER //
// ./src/actions/authActionCreators.js